// importando a estilização do botão
import "./style.css";

// Componente de botão de enviar
export function ButtonSend(props) {
  return (
    <button className="buttonSend">Enviar</button>
  );
}